'use client';

import { Button, Transition, Typography } from 'components';
import { ContentGenerationClipArt } from 'lib/svgs/ClipArts';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/navigation';
import { useContentGenerationListContext } from './_context/ContentGenerationListContext';

export default function ContentGenerationPage() {
  const t = useTranslations();
  const router = useRouter();
  const { refetch, hasNodes, isChecking } = useContentGenerationListContext();

  const handleClick = () => router.push('/content-creator/new');

  if (!!hasNodes && !isChecking) return null;

  return (
    <div className="flex h-full flex-1 flex-col items-center justify-center">
      <Transition className="mb-14 flex h-24 justify-center">
        <ContentGenerationClipArt className="h-[170px] w-[170px]" />
      </Transition>
      <Transition delay={0.4}>
        <div className="mb-6 mt-12">
          <Typography variant="medium7xl" className="!mt-0 flex justify-center text-tertiary-100">
            {t('content_generation.intro.title')}
          </Typography>
        </div>
        <div className="mb-12 max-w-3xl">
          <Typography variant="light3" className="m-0 !leading-7 text-tertiary-200">
            <div className="text-center">{t('content_generation.intro.paragraph.one')}</div>
          </Typography>
        </div>
      </Transition>
      <Transition delay={1} className="flex">
        <Button label={t('content_generation.start_creating')} onClick={handleClick} />
      </Transition>
    </div>
  );
}
